import store from 'flux'

function isEmpty(value){
  return (value == null || value.length === 0);
}

const validate = values => {
  const errors = {}

  //EMAIL
  if(values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)){
    errors.email = "Invalid Email Address";
  }

  //check phone
  if(values.phone){
    const onlyNums = values.phone.replace(/[^\d]/g, '');
    if(onlyNums.length < 10){
      errors.phone = "Valid phone number required"
    }
  }

  //zipCode
  if(values.zipCode && !/^\d{5}(?:[-\s]\d{4})?$/.test(values.zipCode)){
    errors.zipCode = "Valid Zip Code is required"
  }

  //REQUIRED
  let requiredFields = [
    "firstName",
    "lastName",
    "streetAddress",
    "city",
    "state",
    "zipCode",
    "phone",
    "email",
    "eighteenOrOver",
    "authorized",
    "referralSource"
  ];

  if(store.getState().config.askAboutCrime){
    requiredFields.push("convicted");
    if(values.convicted == "true"){
      requiredFields.push("convictedDescription");
    }
  }

  if(!isEmpty(values.eighteenOrOver) && values.eighteenOrOver == "false"){
    //if eighteenOrOver is filled out and is false, require the numeric age
    requiredFields.push("statedAge");
  }

  requiredFields.forEach(function(field){
    if(isEmpty(values[field])){
      errors[field] = 'Required';
    }
  });





  return errors
}

export default validate
